/*
 * @Description:状态管理异步请求
 * @Author: kai.zhou
 * @Date: 2020-03-25 20:46:24
 * @LastEditors: Mayer
 * @LastEditTime: 2023-04-11 14:40:33
 */
import WebApi from "./webApi";
import * as store from "./store";

const actor = (state: any = store.store) => ({
  //获取Banner图片
  getBannerImg: async (mcc?: any) => {
    let res: any = await WebApi.getBannerImg({ country: state.getState().defaultState.countryActive.mcc });
    if (res && res.code === 200) {
      let a = res.data && res.data.imgUrl;
      //"https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1586945891097&di=546a7e19b794f27ede5aa9c411dca446&imgtype=0&src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fimages%2F20170922%2F8968cffa2d844f14a5f6994e55b7d1b7.jpeg";
      state.dispatch(store.getBannerImg(a));
    }
  },
  //获取国家列表
  getCountries: async () => {
    let res: any = await WebApi.getCountries({});
    if (res && res.code === 200) {
      let a = res.data;
      state.dispatch(store.getCountryList(a));
    }
  },
});

export default actor();
